// Lib
import React, { ReactElement, ReactNode } from 'react';
import classNames from 'classnames';

// Styles
import './MobileHeader.scss';

interface MobileHeaderProps {
    className?: string;
    children?: ReactNode;
}

const MobileHeader = (props: MobileHeaderProps): ReactElement => {
    const { children, className } = props;

    return (
        <div className={classNames('MobileHeader', className)}>
            <div className="mobile-header-safe-area-padding" />
            <div className="mobile-header-content">{children}</div>
        </div>
    );
};

export default MobileHeader;
